export default "__VITE_ASSET__BREXI9Vv__"